import { APIGet, APIPost, APIPut, IAPIResponse, APIUrl, AdminType, StatusCode } from "api/protocols";
import { CancelToken } from "axios";

interface IGetCustomerCredit {
  customer_id?: number;
  facility_id?: number;
}

interface ICustomerCreditRes {
  status: StatusCode;
  message?: string;
  data: any;
}

interface IPostCreditBook {
  title?: string;
  customer_id?: number;
}

interface IGetCreditTransactionsParams {
  credit_book_id: number;
  customer_id?: number;
  id?: number;
  facility_id?: number;
  limit?: number;
  offset?: number;
  with_total?: boolean;
  sort_by?: "processed_at_local" | "created_at";
  sort_direction?: "asc" | "desc";
}

export interface ICreditTransactionsPaginatedResult {
  transactions: ICreditTransactionRes[];
  total: number;
}

interface IGetCreditTransactions extends IAPIResponse {
  data: Array<ICreditTransactionRes> | ICreditTransactionsPaginatedResult;
}

export function isPaginatedCreditTransactions(
  data: Array<ICreditTransactionRes> | ICreditTransactionsPaginatedResult,
): data is ICreditTransactionsPaginatedResult {
  return !Array.isArray(data) && Array.isArray(data.transactions);
}

export interface ICreditBook {
  id: number;
  client_id: number;
  type: "credit_book" | "prize_account";
  facility_id: number;
  customer_id: number;
  league_id: number;
  tournament_id: number;
  balance: number;
  currency: string;
  title: string;
}

export interface ICreditTransactionRes {
  id: number;
  credit_book_id: number;
  facility_id: number;
  client_id: number;
  customer_id: number;
  amount: number;
  currency: string;
  kind: string;
  parent_id: number;
  order_id: number;
  order_number: string;
  order_name: string;
  processed_at_local: string;
  voided_at: string | null;
  note: string;
}
export async function GetCustomerCredit(
  params: IGetCustomerCredit,
  useGlobalLoader?: boolean,
  cancelToken?: CancelToken,
): Promise<ICustomerCreditRes> {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/client/credit-book"), params, useGlobalLoader, cancelToken);
}

export async function PostCustomerCreditBook(params: IPostCreditBook, useGlobalLoader: true) {
  return APIPost(APIUrl(AdminType.FacilityAdmin, "/client/credit-book"), params, useGlobalLoader);
}

export async function GetCreditBookTransactions(
  params: IGetCreditTransactionsParams,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IGetCreditTransactions> {
  return APIGet(APIUrl(AdminType.FacilityAdmin, "/client/credit-book/transaction"), params, useGlobalLoader, token);
}

interface IPutCreditBookTransactionNote {
  id: number;
  note: string;
}

export async function PutCreditBookTransactionNote(params: IPutCreditBookTransactionNote, useGlobalLoader: boolean) {
  return APIPut(APIUrl(AdminType.FacilityAdmin, "/client/credit-book/transaction"), params, useGlobalLoader);
}
